import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'negToParnth'
})
export class NegToParnthPipe implements PipeTransform {


  public transform(value: any, args?: any): any {

    return value.indexOf('-') >= 0 ?
    '$(' + value.substring(2, value.length) + ')' :
    value;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/neg-to-parnth.pipe.ts